import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { loadXP, getLevelInfo } from '../data/xp';
import { isAuthenticated, isOrgAdmin, isSuperAdmin, getUserName, getLoginURL, getLogoutURL, clearSession, getStoredToken } from '../auth/cognito';
import { isDemoMode, setDemoMode } from '../data/progress';

const API_URL = 'https://0emko5cw6f.execute-api.ca-central-1.amazonaws.com/prod';

export default function Nav() {
  const xp = loadXP();
  const { current } = getLevelInfo(xp.total);
  const authed = isAuthenticated();
  const orgAdmin = isOrgAdmin();
  const superAdmin = isSuperAdmin();
  const name = getUserName();
  const [demo, setDemo] = useState(isDemoMode());

  async function handleSignOut(e: React.MouseEvent) {
    e.preventDefault();
    const token = getStoredToken();
    if (token) {
      try {
        await fetch(`${API_URL}/pub/logout`, { method: 'POST', headers: { Authorization: token } });
      } catch { /* proceed with local logout even if server revocation fails */ }
    }
    clearSession();
    window.location.href = getLogoutURL();
  }

  function toggleDemo() {
    const next = !demo;
    setDemoMode(next);
    setDemo(next);
  }

  return (
    <nav style={{
      background: '#1e1b4b',
      padding: '0 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 56,
      position: 'sticky',
      top: 0,
      zIndex: 100,
      borderBottom: '1px solid rgba(255,255,255,0.06)',
    }}>
      {/* Logo */}
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}>
        <span style={{ fontSize: 18, fontWeight: 800, color: '#e0e7ff', letterSpacing: '-0.5px' }}>
          privacy<span style={{ color: '#818cf8' }}>.</span>education
        </span>
      </Link>

      {/* Right side */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {authed ? (
          <>
            {orgAdmin && (
              <Link to="/portal" style={{
                fontSize: 13, color: '#a5b4fc', textDecoration: 'none',
                padding: '4px 10px', borderRadius: 6,
                border: '1px solid rgba(165,180,252,0.2)',
              }}>
                Team Portal
              </Link>
            )}

            {superAdmin && (
              <button
                onClick={toggleDemo}
                title={demo ? 'Demo mode on — all modules unlocked. Click to turn off.' : 'Turn on demo mode to unlock all modules'}
                style={{
                  fontSize: 12, fontWeight: 700, cursor: 'pointer',
                  padding: '4px 10px', borderRadius: 6, border: 'none',
                  background: demo ? '#f59e0b' : 'rgba(255,255,255,0.08)',
                  color: demo ? '#1c1917' : '#6b7280',
                  transition: 'all 0.15s',
                }}
              >
                {demo ? 'Demo ON' : 'Demo'}
              </button>
            )}

            {/* XP badge */}
            <div style={{
              fontSize: 13, color: '#c7d2fe', fontWeight: 600,
              background: 'rgba(255,255,255,0.06)',
              borderRadius: 8, padding: '4px 12px',
            }}>
              Lv.{xp.level} &middot; {xp.total} XP
              <span style={{ color: '#818cf8', marginLeft: 6, fontWeight: 400 }}>{current.label}</span>
            </div>

            {/* User + sign out */}
            <span style={{ fontSize: 13, color: '#6b7280', maxWidth: 120, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {name}
            </span>
            <a
              href={getLogoutURL()}
              onClick={handleSignOut}
              style={{
                fontSize: 13, color: '#818cf8', fontWeight: 600,
                textDecoration: 'none', padding: '4px 10px',
                border: '1px solid rgba(129,140,248,0.3)', borderRadius: 6,
              }}
            >
              Sign out
            </a>
          </>
        ) : (
          <a href={getLoginURL()} style={{
            fontSize: 14, fontWeight: 700, color: 'white',
            background: 'rgba(255,255,255,0.12)',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: 8, padding: '7px 16px',
            textDecoration: 'none',
          }}>
            Sign in
          </a>
        )}
      </div>
    </nav>
  );
}
